import { resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_ctx.componentName)
    ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.componentName), _mergeProps({ key: 0 }, _ctx.componentModel, {
        onClose: $options.close,
        onSubmit: $options.submit
      }), null, 16 /* FULL_PROPS */, ["onClose", "onSubmit"]))
    : _createCommentVNode("v-if", true)
}